module.exports = __webpack_public_path__ + "static/media/BLUSH_3241.b273c4b6.jpg";